import {
    container,
    infoColor,
    successColor,
    warningColor,
    dangerColor,
    roseColor,
    transition,
    boxShadow,
    drawerWidth,
  } from '../../constants'
  
  const headerStyle = {
    appBar: {
      display: 'flex',
      border: '0',
      borderRadius: '3px',
      padding: '0.625rem 0',
      marginBottom: '20px',
      color: '#555',
      width: '100%',
      backgroundColor: '#fff',
      boxShadow: '0 4px 18px 0px rgba(0, 0, 0, 0.12), 0 7px 10px -5px rgba(0, 0, 0, 0.15)',
      transition: 'all 150ms ease 0s',
      alignItems: 'center',
      flexFlow: 'row nowrap',
      justifyContent: 'flex-start',
      position: 'relative',
      zIndex: 'unset',
    },
    topbar: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      
    },
    menuButton: {
      backgroundColor: '#000',
      '&:hover': {
        background: '#1c1c1c',
      },
      minWidth: '34px',
      minHeight: '34px',
    },
    menuIcon: {
      color: '#2c747c',
    },
    appResponsive: {
      margin: '20px 10px',
    },
    black: {
      height: '80px',
      backgroundColor: 'black',
      color: 'white',
      fontFamily: '"Permanent Marker", cursive',
      fontWeight: '400',
      fontSize: '50px',
      textAlign: 'center',
    },
    transparent: {
      height: '80px',
      backgroundColor: 'transparent',
      color: 'teal',
      fontFamily: '"Permanent Marker", cursive',
      fontWeight: '400',
      fontSize: '50px',
      textAlign: 'center',
    },
    logo: {
      width: '40px',
      height: '40px',
    },
    title: {
      flexGrow: 1,
      textAlign: 'center',
      fontFamily: '"Permanent Marker", cursive',
      fontWeight: '400',
      fontSize: '70px',
    },
    drawerPaper: {
      backgroundColor: 'gray',
      border: 'none',
      bottom: '0',
      transitionProperty: 'top, bottom, width',
      transitionDuration: '.2s, .2s, .35s',
      transitionTimingFunction: 'linear, linear, ease',
      width: drawerWidth,
      ...boxShadow,
      position: 'fixed',
      display: 'block',
      top: '0',
      height: '100vh',
      right: '0',
      left: 'auto',
      visibility: 'visible',
      overflowY: 'visible',
      borderTop: 'none',
      textAlign: 'left',
      paddingRight: '0px',
      paddingLeft: '0',
      ...transition,
    },
  }
  
  export default headerStyle